module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-down.b4a91f13.svg";